<template>
  <v-snackbar
    v-model="snackbarOpen"
    :timeout="0"
    color="error"
    bottom
    right
    auto-height
    vertical
  >
    <v-container>
      <v-layout column>
        <v-flex>
          <v-layout align-center>
            <v-flex class="flex-shrink">
              <v-icon
                color="white"
                large
              >
                error
              </v-icon>
            </v-flex>
            <v-flex class="flex-grow">
              <span class="snackbar-title text&#45;&#45;white">{{ title }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          {{ message }}
        </v-flex>
        <v-flex>
          <p v-for="(error, index) in errors" :key="index" class="err-line">
            <span>{{ error }}</span>
          </p>
        </v-flex>
      </v-layout>
    </v-container>
    <v-btn
      dark
      flat
      @click="snackbarOpen=false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'errors-snackbar',
  props: {
    open: Boolean,
    errors: Array,
    title: String,
    message: String,
  },
  data() {
    return {
      snackbarOpen: this.open,
    }
  },
  watch: {
    open(value) {
      this.snackbarOpen = value
    },
    snackbarOpen(current, prev) {
      if (current !== prev) {
        this.$emit('update:open', current)
      }
    },
    errors(value) {
      this.$emit('update:errors', value)
    },
  },
}
</script>

<style scoped>
</style>
